module.exports = __webpack_public_path__ + "static/media/Introduction to Custom Questionnaires.02d0c249.png";